export const EDIT_SPECIAL_AUTHORIZATIONS_SUCCESS = 'EDIT_SPECIAL_AUTHORIZATIONS_SUCCESS';
export const CLEAR_SPECIAL_AUTHORIZATIONS = 'CLEAR_SPECIAL_AUTHORIZATIONS';
export const UPDATE_SPECIAL_AUTHORIZATIONS_SUCCESS = 'UPDATE_SPECIAL_AUTHORIZATIONS_SUCCESS';
